import { FC } from 'react';
import { Box } from '@bpba/ui-components';
import { Phone } from '../../model/Phone';
import { InputNumber } from '../shared/form/InputNumber';
import { InputContainerProps } from './InputSelectContainer';
import { PHONE_NUMBER_MAX_LENGTH, PHONE_NUMBER_MIN_LENGTH, PHONE_PREFIX_MAX_LENGTH, PHONE_PREFIX_MIN_LENGTH } from '../../constants/form';

type Props = InputContainerProps<Phone>;

export const FormularioTelefono: FC<Props> = ({ register, errors }) => {
  return (
    <Box>
      <InputNumber
        placeholder="Prefijo (ej: 011)"
        name="prefix"
        mr={'16px'}
        width="40%"
        minWidth={98}
        required={true}
        formRegister={register}
        errorCollection={errors}
        minLength={PHONE_PREFIX_MIN_LENGTH}
        maxLength={PHONE_PREFIX_MAX_LENGTH}
      />
      <InputNumber
        width="60%"
        placeholder="Número (ej: 12345678)"
        name="telephone"
        mr={0}
        required={true}
        formRegister={register}
        errorCollection={errors}
        minLength={PHONE_NUMBER_MIN_LENGTH}
        maxLength={PHONE_NUMBER_MAX_LENGTH}
      />
    </Box>
  );
};
